import { render, staticRenderFns } from "./OrderingEquipment.vue?vue&type=template&id=b7b8e26e&lang=pug&"
import script from "./OrderingEquipment.vue?vue&type=script&lang=js&"
export * from "./OrderingEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports